export let Breakpoint = /*#__PURE__*/function (Breakpoint) {
  Breakpoint["LARGE"] = "large";
  Breakpoint["SMALL"] = "small";
  return Breakpoint;
}({});
export const DEFAULT_BREAKPOINT = Breakpoint.LARGE;
//# sourceMappingURL=breakpoints.js.map